import React from 'react';
import './HeroBanner.css';

function HeroBanner({ title, subtitle, instructor, backgroundColor, image }) {
  const style = {
    background: backgroundColor || `linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%)`,
  };

  return (
    <section className={`hero-banner ${image ? 'hero-banner--with-image' : ''}`} style={style}>
      <div className={`container ${image ? 'hero-banner__layout' : ''}`}>
        {image && (
          <div className="hero-banner__image-wrapper">
            <img src={image} alt={title} className="hero-banner__image" />
          </div>
        )}
        <div className="hero-banner__text">
          {subtitle && <p className="hero-banner__subtitle">{subtitle}</p>}
          <h1 className="hero-banner__title">{title}</h1>
          {instructor && <p className="hero-banner__instructor">{instructor}</p>}
        </div>
      </div>
    </section>
  );
}

export default HeroBanner;
